const alt = require('components/alt');
const ZopimActions = require('./zopim_actions.js');

class ZopimStore {
  constructor() {
    this.chatOnline = false;

    this.bindListeners({
      handleOnlineStatusUpdated: ZopimActions.ONLINE_STATUS_UPDATED,
    });
  }

  handleOnlineStatusUpdated(status) {
    this.chatOnline = status;
  }
}

module.exports = alt.createStore(ZopimStore, 'ZopimStore');



// WEBPACK FOOTER //
// ./javascripts/components/zopim/zopim_store.js